import type { ShareLinkDestination } from './resolveShareLink'

/** The RUM action a resolved share link reports. */
export const SHARE_LINK_OPENED_ACTION = 'share_link_opened'

export interface ShareLinkOpenedContext {
  /** The link's scope, as far as it is known. */
  scope: 'map_pin' | 'map_line' | 'unknown'
  /** The app's `objectType` vocabulary, so web and app opens break down the same way. */
  objectType: 'mapPin' | 'location' | 'mapLine' | 'unknown'
  outcome: 'shown' | 'forwarded' | 'invalid' | 'unreachable'
}

/**
 * What to report about a resolved share link, or null when the page it leads to
 * reports for itself — a replay link reaches the replay, which records
 * `replay_viewed` with its own source.
 *
 * Nothing that identifies the link goes in: the code is the link's access key,
 * and the ids and coordinates belong to someone's map.
 */
export function shareLinkOpenedContext(destination: ShareLinkDestination): ShareLinkOpenedContext | null {
  switch (destination.kind) {
    case 'sharedReplay':
    case 'huntReplay':
      return null
    case 'mapPin':
      return {
        scope: 'map_pin',
        objectType: destination.pin.kind === 'location' ? 'location' : 'mapPin',
        outcome: 'shown',
      }
    case 'mapLine':
      return { scope: 'map_line', objectType: 'mapLine', outcome: 'shown' }
    case 'elsewhere':
      return { scope: 'unknown', objectType: 'unknown', outcome: 'forwarded' }
    case 'invalid':
      return { scope: 'unknown', objectType: 'unknown', outcome: 'invalid' }
    case 'unreachable':
      return { scope: 'unknown', objectType: 'unknown', outcome: 'unreachable' }
  }
}
